// write home page here
const Workout = () => {
    return (
        <div>
        <h1>Workout Page</h1>
        </div>
    );
}
export default Workout;